// TODO: Add deviceTypes from RTDB
const deviceTypes = {
    RFID: 'RFID',
    bar_code: 'Bar Code',
    key_fob: 'Key Fob',
    key_pad: 'Key Pad',
    nfc: 'NFC',
    test_type: 'Test Type'
};

export class AccessLogHelper {
    static getLogType(log) {
        if (log.lpr_access) return 'LPR';
        if (log.role === 'otc' || log.access_type === 'visitor') return 'Visitor';
        if (log.guard_access) return 'Guard';

        switch (log.access_type) {
            case 'emergency':
                return 'Emergency';
            case 'scan':
                return 'Access Key';
            case 'kiosk':
                return 'Call';
            case 'ca4k':
                return 'CA4K';
            default:
                return deviceTypes[log.access_type] || '';
        }
    }

    static formatAccessTime(inputDate) {
        const date = new Date(inputDate);
        const today = new Date();
        const oneWeekAgo = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate() - 7
        );

        const isSameDay = (d1, d2) => {
            return d1.toDateString() === d2.toDateString();
        };

        const pastOptions = {
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        };

        if (isSameDay(date, today)) {
            const time = date.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            });
            return `Today, ${time}`;
        }

        if (date > oneWeekAgo) {
            const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
            const time = date.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            });
            return `${weekday} at ${time}`;
        }

        return date.toLocaleString('en-US', pastOptions);
    }
}
